// extracted by mini-css-extract-plugin
export default {"cabecalho":"BannerFormacoes_cabecalho__o8Mzf","cabecalho__info":"BannerFormacoes_cabecalho__info__5G0hk","logo":"BannerFormacoes_logo__mZjfu"};